import React from 'react';
import { IPaymentToken } from 'utils/api/models/payments/paymentTokens';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import SingleCard from './subcomponents/SingleCard';
import NoCardsAdded from './subcomponents/NoCardsAdded';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/walletStyle';
import GridContainer from 'components/Grid/GridContainer';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICardsListProps {
	paymentTokens: IPaymentToken[];
	removeToken: (id: string, last4Digits: string) => void;
}

const CardsList = ({ paymentTokens, removeToken }: ICardsListProps) => {
	const classes = useStyles();

	return (
		<ConditionalRender
			show={paymentTokens.length > 0}
			onTrue={() => (
				<GridContainer justify="flex-start" className={classes.cardsListWrapper}>
					{paymentTokens.map((paymentToken, index) => (
						<SingleCard
							key={index}
							paymentToken={paymentToken}
							removeToken={(last4Digits: string) => removeToken(paymentToken.id, last4Digits)}
						/>
					))}
				</GridContainer>
			)}
			onFalse={() => <NoCardsAdded />}
		/>
	);
};

export default CardsList;
